import axios from '@/libs/api.request'

export const getSkipPathList = (page, limit, key) => {
  return axios.request({
    url: '/v1/system/security-skip-path/',
    method: 'get',
    params: {
      page,
      limit,
      key: key
    }
  })
}

export const operationSkipPath = (data, meth) => {
  return axios.request({
    url: '/v1/system/security-skip-path/',
    method: meth,
    data
  })
}